/**
 * Font stylesheet URL policy. Pure (no logger, no Node built-ins) because the
 * brand-settings UI loads these stylesheets into the app page and validates
 * with the same check the agent review schema uses.
 */

// Hosts that serve only `@font-face` CSS. A stylesheet from any other host,
// such as a CDN serving arbitrary repos, can restyle or read the page it loads into.
export const FONT_STYLESHEET_HOSTS = [
  "fonts.googleapis.com",
  "fonts.bunny.net",
  "use.typekit.net",
] as const;

export type FontStylesheetUrlProblem = "invalid-url" | "not-https" | "host";

/** Why `url` can't be loaded as a font stylesheet, or null when it can. */
export function fontStylesheetUrlProblem(
  url: string,
): FontStylesheetUrlProblem | null {
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    return "invalid-url";
  }
  if (parsed.protocol !== "https:") return "not-https";
  // The app CSP allows these hosts on the default port only.
  if (
    parsed.port !== "" ||
    !FONT_STYLESHEET_HOSTS.some((host) => host === parsed.hostname)
  ) {
    return "host";
  }
  return null;
}

export function isAllowedFontStylesheetUrl(url: string): boolean {
  return fontStylesheetUrlProblem(url) === null;
}
